import React, { createContext } from 'react'

import * as Reducers from './reducers'

const Context = createContext(Reducers.globalInitialState)

export default Context
